import { AnimatePresence } from 'motion/react';
import styled from 'styled-components';

import { NAVIGATION_MENU_WIDTH } from 'common/constants';
import { useSnackbar } from 'common/hooks/useSnackbar';
import { media } from 'common/media';

import { Snackbar } from './Snackbar';

const Root = styled.div`
  z-index: 10;
  position: fixed;
  bottom: 16px;
  left: 16px;
  right: 16px;
  @media ${media.xl} {
    bottom: 36px;
    left: 50%;
    transform: translate(-50%);
  }
`;

const Content = styled.div`
  @media ${media.xl} {
    margin-left: ${NAVIGATION_MENU_WIDTH}px;
  }
`;

export const Snackbars = ({ displayDurationDefault }: { displayDurationDefault?: number }) => {
  const { snackbars } = useSnackbar();

  return (
    <Root>
      <Content>
        <AnimatePresence>
          {snackbars.map((snackbar) => (
            <Snackbar
              key={snackbar.id}
              {...snackbar}
              id={snackbar.id!}
              displayDuration={snackbar.displayDuration ?? displayDurationDefault}
            />
          ))}
        </AnimatePresence>
      </Content>
    </Root>
  );
};
